import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import swal from 'sweetalert2';
import { LmsContentEditorComponent } from '../../lms-layout/lms-content-editor/lms-content-editor.component';

@Component({
  selector: 'app-list-admin',
  templateUrl: './list-admin.component.html',
  styleUrls: ['./list-admin.component.scss'],
  encapsulation: ViewEncapsulation.None,  

})
export class ListAdminComponent implements OnInit {


  @ViewChild(DatatableComponent) table: DatatableComponent;
  @ViewChild('name') inputName;

  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = ''
  isFilter: boolean = false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Job For", prop: "job_for" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;
  user_role: any
  main_menu_id:any
  activeTab:any
  discussion_id:any

  guideline_data:any
  row_id:any
  model_answer:any
  discussion_status =[
    {name:'pending'},
    {name:'completed'},
    {name:'decline'}
  ]
  appType:any
  selectedApp = null
  @Output() refreshData = new EventEmitter<any>();
  @ViewChild('modalRef') modal: LmsContentEditorComponent;
  app_type_list=[
    {name:'Image'},
    {name:'Video'},
    {name:'Text'}
  ]
  selected_app_type =null
  constructor(public apiService: ApiService, private spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private session: SessionStorageService, private activerouter: ActivatedRoute,
    private route: Router,) {
    this.user_role = JSON.parse(localStorage.getItem('user'))
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Discussions') 
    this.guideline_data = key_data[0]?._id

    // this.activeMenuTab('mainmenu')

  }

  

  ngOnInit() {
    this.getDiscussionList()
    // this.setAndGetEnrollmentsbyStatus()
  }
  // activeMenuTab(tab){
  //   const activeTab = tab
  //   if(activeTab !==''){
  //     this.route.navigate(
  //       [],
  //       { relativeTo: this.activerouter , queryParams: {activeMenu:activeTab} }
  //       )
  //   }
  // }
  // setAndGetEnrollmentsbyStatus() {
  //   this.activerouter.queryParams
  //     .subscribe((params: any) => {
  //       this.activeTab = params?.activeMenu;
  //       switch (this.activeTab) {
  //         case 'mainmenu':
  //           this.getMenusList(this.activeTab);
  //           break;
  //         case 'submenu':
  //           this.getMenusList(this.activeTab);
  //           break
        
  //          default:
  //           this.activeTab = ''
  //       }
  //     })
  // }
  editDiscussion(row) {
    this.route.navigate(['discussions/edit', row?._id])
  }
  getDiscussionList() {
   
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
      this.apiService.getDiscussionList(this.page.pageNumber+1,this.page.pageSize).subscribe((res: any) => {
        this.spinner.hide()
        this.rows=res.items
        this.page.totalPages = res.total
      })
  }

  pageChangeData(page: any) {
    // this.spinner.show(undefined,
    //   {
    //     type: 'ball-triangle-path',
    //     size: 'medium',
    //     bdColor: 'rgba(0, 0, 0, 0.8)',
    //     color: '#fff',
    //     fullScreen: true
    //   });
    // this.apiService.getAllJobs(page.offset + 1, page.pageSize).subscribe((res: any) => {
    //   this.spinner.hide()
    //   this.rows = res.data.items
    //   this.page.totalPages = res.data.totalCount
    // })
  }
 
  deleteDiscussion(id) {
    this.apiService.deleteDiscussion(id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getDiscussionList()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }

    })
  }

  // ================== Delete Alert ========================
  Delete(id: any) {
    this.discussion_id = id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to delete this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.deleteDiscussion(this.discussion_id)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  openAnswerModal(content,id) {
    this.row_id = id
   
   
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content,options);
    modalRef.result.then((result) => {
      
      this.row_id = null
    }, (reason) => {
      
      this.row_id = null
    });
  }
  discussionUpdate(){
    let body={
      answer : this.model_answer,
      status: 'completed'
    }
   
    this.apiService.updateDiscussion(this.row_id,body).subscribe((res:any)=>{
      if(res.statusCode===200){
        this.toastr.success('answer updated successfull!')
        this.modalService.dismissAll()
        this.getDiscussionList()
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  updateDiscussionStatus(id,status){
    let body={
      status: status
    }
    this.apiService.updateDiscussion(id,body).subscribe((res:any)=>{
      if(res.statusCode===200){
        this.toastr.success('status updated successfull!')
        this.modalService.dismissAll()
        this.getDiscussionList()
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  getAppType(event){
    this.selected_app_type = event.name
    console.log('this.selected_app_type =>',this.selected_app_type)
    this.addApp(this.selected_app_type)
  }
  addApp(data) {
    console.log('=>>',data)
    this.appType = data.toLowerCase()
    this.selectedApp=null
  }
  editApp(app) {
    this.selectedApp = app
    this.appType=null
  }
  closeModel(): void {
    this.refreshData.emit()
    this.getDiscussionList()
  }

}